import {
  getMagazineViewHistoriesAPI,
  getMagazineViewHistoriesExcelAPI,
} from '@/src/apis/rest/magazine';
import Button from '@/src/components/atom/Button';
import Dialog from '@/src/components/atom/Dialog';
import ExcelDownloadButton from '@/src/components/atom/ExcelDownloadButton';
import Table from '@/src/components/atom/Table';
import { BUTTON_CONST } from '@/src/constants/buttons';
import { magazineViewHistoryListColumn } from '@/src/pages/Magazine/column';
import { useQuery } from '@tanstack/react-query';
import { AgGridReact } from 'ag-grid-react';
import { useRef, useState } from 'react';

interface MagazineViewHistoriesModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  id: number | null;
}

export default function MagazineViewHistoriesModal({
  open: openProps,
  onOpenChange,
  id,
}: MagazineViewHistoriesModalProps) {
  // state
  const gridRef = useRef<AgGridReact>(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // query
  const {
    data: viewHistoriesData,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['magazine-view-histories', id, page, pageSize],
    queryFn: () => {
      return getMagazineViewHistoriesAPI({ id: Number(id), page, pageSize });
    },
    enabled: !!id,
  });

  // event
  const handleCloseModal = () => {
    onOpenChange(false);
  };
  const handlePageChange = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };

  // render
  const renderFooter = () => {
    return (
      <div className="flex justify-end gap-2">
        <Button
          className="flex-1"
          buttonColor="outline"
          onClick={handleCloseModal}
        >
          {BUTTON_CONST.cancel}
        </Button>
        <Button type="submit" className="flex-1" onClick={handleCloseModal}>
          {BUTTON_CONST.ok}
        </Button>
      </div>
    );
  };

  return (
    <>
      <Dialog
        open={openProps}
        onOpenChange={handleCloseModal}
        contentProps={{
          style: {
            width: 'calc(100vw - 24px)',
          },
          className: 'max-w-[967px]',
        }}
        title={
          <div className="flex items-center gap-2">
            조회한 회원 목록
            <ExcelDownloadButton
              disabled={
                isError || isFetching || !viewHistoriesData?.rows?.length
              }
              buttonSize="small"
              fileName="매거진_조회_회원_리스트"
              downloadExcelAPI={getMagazineViewHistoriesExcelAPI}
              searchParams={{ id }}
            />
          </div>
        }
        footer={renderFooter()}
      >
        <Table
          ref={gridRef}
          rowData={isError ? [] : viewHistoriesData?.rows || []}
          isPaginationDataMapping
          columnDefs={magazineViewHistoryListColumn}
          total={viewHistoriesData?.count || 0}
          page={page}
          pageSize={pageSize}
          handlePaginationClick={handlePageChange}
        />
      </Dialog>
    </>
  );
}
